export default __webpack_public_path__ + "../staticImages/flagge_spanien-260.png";